define("settings/components/monthly-post-usage-item", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class={{concat-classes "u--col__6 u--p__t" (lowercase (concat "qa--settings--postsUsed_" @profile.type))}}>
  
    <p class="u--text--md">
      {{@profile.type}}
      {{#if @profile.hasProfiles}}
        {{#if @profile.hasLimit}}
          <span class="u--float--right u--text--sm qa--postLimit_countdown" data-test-id="has-limit">
            {{t "account.overview.post_usage.counter" current=@profile.current max=@profile.max}}
          </span>
        {{else}}
          <span class="u--float--right u--text--sm u--text--light" data-test-id="no-limit">
            {{t "account.overview.post_usage.no_post_limit"}}
          </span>
        {{/if}}
      {{else}}
        <span class="u--float--right u--text--sm u--text--light" data-test-id="no-profiles">
          {{t "account.overview.post_usage.no_profiles_connected"}}
        </span>
      {{/if}}
    </p>
    <div class="o--progress">
      <span
        class="o--progress__line {{if @profile.isDisabled 'o--progress__line--inactive'}}"
        style={{@profile.percentCSS}}
      ></span>
    </div>
  </div>
  */
  {
    "id": "nGj01hzx",
    "block": "[[[10,0],[15,0,[28,[37,0],[\"u--col__6 u--p__t\",[28,[37,1],[[28,[37,2],[\"qa--settings--postsUsed_\",[30,1,[\"type\"]]],null]],null]],null]],[12],[1,\"\\n\\n  \"],[10,2],[14,0,\"u--text--md\"],[12],[1,\"\\n    \"],[1,[30,1,[\"type\"]]],[1,\"\\n\"],[41,[30,1,[\"hasProfiles\"]],[[[41,[30,1,[\"hasLimit\"]],[[[1,\"        \"],[10,1],[14,0,\"u--float--right u--text--sm qa--postLimit_countdown\"],[14,\"data-test-id\",\"has-limit\"],[12],[1,\"\\n          \"],[1,[28,[35,4],[\"account.overview.post_usage.counter\"],[[\"current\",\"max\"],[[30,1,[\"current\"]],[30,1,[\"max\"]]]]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,1],[14,0,\"u--float--right u--text--sm u--text--light\"],[14,\"data-test-id\",\"no-limit\"],[12],[1,\"\\n          \"],[1,[28,[35,4],[\"account.overview.post_usage.no_post_limit\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]]],[]],[[[1,\"      \"],[10,1],[14,0,\"u--float--right u--text--sm u--text--light\"],[14,\"data-test-id\",\"no-profiles\"],[12],[1,\"\\n        \"],[1,[28,[35,4],[\"account.overview.post_usage.no_profiles_connected\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"o--progress\"],[12],[1,\"\\n    \"],[10,1],[15,0,[29,[\"o--progress__line \",[52,[30,1,[\"isDisabled\"]],\"o--progress__line--inactive\"]]]],[15,5,[30,1,[\"percentCSS\"]]],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@profile\"],false,[\"concat-classes\",\"lowercase\",\"concat\",\"if\",\"t\"]]",
    "moduleName": "settings/components/monthly-post-usage-item.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});